import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function LogoutPage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const postLogoutRedirectUri = searchParams.get('post_logout_redirect_uri');
  const idTokenHint = searchParams.get('id_token_hint');
  const state = searchParams.get('state');

  const handleLogout = async () => {
    setLoading(true);

    try {
      // Call Spring's logout endpoint
      await fetch('/oauth2/logout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          ...(idTokenHint && { id_token_hint: idTokenHint }),
        }),
      });

      // Redirect to post-logout URI or default
      const redirectUrl = new URL(postLogoutRedirectUri || window.location.origin);
      if (state) {
        redirectUrl.searchParams.set('state', state);
      }
      window.location.href = redirectUrl.toString();
    } catch (err) {
      console.error('Logout failed:', err);
      // Still redirect even if logout fails
      window.location.href = postLogoutRedirectUri || window.location.origin;
    }
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <div className="auth-container">
      <div className="auth-header">
        <div className="auth-logo">ZoAuth</div>
        <div className="auth-subtitle">Sign Out</div>
      </div>

      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <svg
          style={{ width: '64px', height: '64px', color: 'var(--warning-color)' }}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>

        <h2 style={{ marginTop: '16px', marginBottom: '8px' }}>
          Are you sure you want to sign out?
        </h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
          You'll need to sign in again to access your account.
        </p>
      </div>

      <div style={{ display: 'flex', gap: '12px', marginTop: '32px' }}>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
          disabled={loading}
          style={{ flex: 1 }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleLogout}
          disabled={loading}
          style={{ flex: 1, background: 'var(--error-color)' }}
        >
          {loading ? (
            <>
              <div className="loading-spinner" />
              Signing out...
            </>
          ) : (
            'Sign Out'
          )}
        </button>
      </div>
    </div>
  );
}
